export async function fetchTranslations(hostname?: string) {
  try {
    const url = hostname
      ? `https://${hostname}/__/translations`
      : '/__/translations';

    await fetch(url)
      .then(response => response.json())
      .then(data => {
        window.__CLIENT_TRANSLATIONS__ = data;
        const event = new CustomEvent('translationsUpdated', {detail: data});
        document.dispatchEvent(event);
      });
  } catch (error) {}
}
